export default [
    /*** 查询系统  ***/
    {
        path: '/query/parameter',
        component: () => import('../pages/query/parameter/index.vue'),
        meta: { title: '参数管理' }
    },
    /*** 基础内容  ***/
    {
        path: '/query/collegebasic',
        component: () => import('../pages/query/collegebasic/index.vue'),
        meta: { title: '参数管理' }
    },
    /*** 内容申请  ***/
    {
        path: '/query/apply',
        component: () => import('../pages/query/apply/index.vue'),
        meta: { title: '内容申请' }
    },
]